import { SVGProps } from "react";

interface CirclePlusProps extends SVGProps<SVGSVGElement> {}

export function CirclePlus(props: CirclePlusProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <rect width={23.4} height={23.4} y={0.6} fill="#007CBF" rx={11.7} />
      <path
        fill="#fff"
        d="M12.15 11.486h3.854v1.375H12.15v3.99h-1.394v-3.99H6.902v-1.375h3.854V7.477h1.394v4.01Z"
      />
    </svg>
  );
}
